import { getDashboardData } from '@deephaven/dashboard';
var EMPTY_OBJECT = Object.freeze({});
var EMPTY_MAP = new Map();
var EMPTY_ARRAY = Object.freeze([]);

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get data for
 * @returns All column objects found in all panels in this dashboard
 */
export var getColumnsForDashboard = (store, dashboardId) => {
  var _getDashboardData$col;
  return (_getDashboardData$col = getDashboardData(store, dashboardId).columns) !== null && _getDashboardData$col !== void 0 ? _getDashboardData$col : EMPTY_ARRAY;
};

/**
 * Get the known filter sets for the dashboard.
 * @param store The redux store
 * @param dashboardId The dashboard ID to get data for
 * @returns The filter sets set on this dashboard
 */
export var getFilterSetsForDashboard = (store, dashboardId) => {
  var _getDashboardData$fil;
  return (_getDashboardData$fil = getDashboardData(store, dashboardId).filterSets) !== null && _getDashboardData$fil !== void 0 ? _getDashboardData$fil : EMPTY_ARRAY;
};

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get data for
 * @returns The filters set on this dashboard
 */
export var getInputFiltersForDashboard = (store, dashboardId) => {
  var _getDashboardData$fil2;
  return (_getDashboardData$fil2 = getDashboardData(store, dashboardId).filters) !== null && _getDashboardData$fil2 !== void 0 ? _getDashboardData$fil2 : EMPTY_ARRAY;
};

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get data for
 * @returns Map from panel ID to the table used in that panel
 */
export var getTableMapForDashboard = (store, dashboardId) => {
  var _getDashboardData$tab;
  return (_getDashboardData$tab = getDashboardData(store, dashboardId).tableMap) !== null && _getDashboardData$tab !== void 0 ? _getDashboardData$tab : EMPTY_MAP;
};

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get the data for
 * @returns The panel ID that is isolated, undefined if none is isolated
 */
export var getIsolatedLinkerPanelIdForDashboard = (store, dashboardId) => getDashboardData(store, dashboardId).isolatedLinkerPanelId;

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get the data from
 * @returns The links for the dashboard
 */
export var getLinksForDashboard = (store, dashboardId) => {
  var _getDashboardData$lin;
  return (_getDashboardData$lin = getDashboardData(store, dashboardId).links) !== null && _getDashboardData$lin !== void 0 ? _getDashboardData$lin : EMPTY_ARRAY;
};

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get the column selection validators for
 * @returns Column selection validator active on a dashboard
 */
export var getColumnSelectionValidatorForDashboard = (store, dashboardId) => getDashboardData(store, dashboardId).columnSelectionValidator;

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get the console settings for
 * @returns Console settings for this dashboard
 */
export var getDashboardConsoleSettings = (store, dashboardId) => {
  var _getDashboardData$con;
  return (_getDashboardData$con = getDashboardData(store, dashboardId).consoleSettings) !== null && _getDashboardData$con !== void 0 ? _getDashboardData$con : EMPTY_OBJECT;
};

/**
 *
 * @param store The redux store
 * @param dashboardId The dashboard ID to get the IdeConnection for
 * @returns The connection for the dashboard
 */
export var getDashboardConnection = (store, dashboardId) => getDashboardData(store, dashboardId).connection;

/**
 *
 * @param store The redux store
 * @param dashboardId The dashboard ID to get the SessionWrapper for
 * @returns The session wrapper for the dashboard
 */
export var getDashboardSessionWrapper = (store, dashboardId) => getDashboardData(store, dashboardId).sessionWrapper;
//# sourceMappingURL=selectors.js.map